import {observer} from "mobx-react-lite";
import React from "react";
import {NumberObservable} from "../../../stores/observables/numberObservable";
import NumberBox from "../../atoms/input/numberBox";
import EditField from "../../molecules/editField/editField";

/**
 * Properties that define a NumberEdit.
 */
export interface INumberEditProps {
  value: NumberObservable;
  label: string;
  /**
   * Optional. Adds a prefix to the number.
   */
  prefix?: string;
  /**
   * Optional. Adds a postfix to the number.
   */
  postfix?: string;
  /**
   * Optional. The increment/decrement of the number. For instance, when set to 2, the increment for 1 will be 1 + 2. Default is 1.
   */
  step?: number;
  /**
   * The message to be displayed when value fails the validation.
   */
  validationMessage?: string;
  placeholder?: string;

  /**
   * Override for disabling the input. If this is null or false, we use the value's disabled property.
   */
  disabled?: boolean;

  /**
   * Optional. When set to true, it does not allow the user to insert a number directly into the NumberBox, only the NumberBox's spinner, up, and down arrow key could change the number.
   * Default is false.
   */
  disableKeyInput?: boolean;
  /**
   * Text to show between label and input
   */
  helpText?: string;
}

const NumberEdit: React.FC<INumberEditProps> = ({
  value,
  label,
  prefix,
  postfix,
  step,
  validationMessage,
  placeholder,
  disableKeyInput = false,
  disabled,
  helpText
}) => {
  return (
    <EditField
      label={label}
      isRequired={value.validate !== undefined}
      helpText={helpText}
    >
      <NumberBox
        value={value}
        prefix={prefix}
        postfix={postfix}
        step={step}
        placeholder={placeholder}
        disabled={disabled}
        disableKeyInput={disableKeyInput}
        errorText={!value.isValid ? validationMessage : ""}
      />
    </EditField>
  );
};

export default observer(NumberEdit);
